import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Coffee, Moon, AlertCircle, Smartphone, Heart } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: FileText,
    text: 'El plan exacto de 7 días (sin pensar qué hacer)'
  }, {
    icon: Coffee,
    text: 'Plantillas de comidas para oficina'
  }, {
    icon: Moon,
    text: 'Reglas mínimas para cenar sin castigarte'
  }, {
    icon: AlertCircle,
    text: 'Protocolo 24 horas si te inflamas por evento'
  }, {
    icon: Smartphone,
    text: 'Tracker listo para notas del celular'
  }, {
    icon: Heart,
    text: 'Tu plan de mantenimiento en 3 reglas personales'
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-brown" data-id="element-4">
            Qué obtienes
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-5">
          {benefits.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="flex items-center gap-4 p-4 rounded-xl hover:bg-cream-50 transition-colors" data-id="element-6">
              <div className="w-10 h-10 rounded-full bg-terracotta/10 flex items-center justify-center text-terracotta flex-shrink-0" data-id="element-7">
                <item.icon size={20} data-id="element-8" />
              </div>
              <span className="text-lg text-brown font-medium" data-id="element-9">
                {item.text}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}